module.exports = __webpack_public_path__ + "static/media/favorite-twitter.1bf0c6b9.svg";